













































































import Vue from 'vue'
import Component from 'vue-class-component'
import UploadManager from '@/modules/media/components/UploadManager.vue'
import { Action } from 'vuex-class'
import { MediaObject } from '@/modules/media/types'
import {MediaListFilters} from '@/modules/media/api'
import {UploadCompletedEvent} from '@/modules/reservation';
import {Prop} from 'vue-property-decorator';


/**
 * Selector de ficheros
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: { 'upload-manager': UploadManager },
})
export default class FileSelector extends Vue {
    public $refs: Vue['$refs'] & {
        uploadManager: {
            upload: () => void,
            clear: () => void,
            queue: MediaObject[],
        },
    }

    @Action('media/objects/load')
    public loadMediaObjects: (filters?: MediaListFilters) => void

    /**
     * Filtrar por tipo de contenido
     *
     * El selector solo mostrará los ficheros cuyos tipos de contenido
     * coincidan con los tipos argumentados en la propiedad
     *
     * @property { string[] }
     */
    @Prop({type: Array, default: () => []})
    public filterByType: string[]

    public filters = new MediaListFilters()

    public selected: MediaObject[] = []
    public activeTab = 0
    public loading = false

    /**
     * Selección multiple
     */
    @Prop({type: Boolean, default: false})
    public multiselect: boolean

    public get mediaObjects () {
        const media: MediaObject[] = this.$store.state.media.objects
        if (!this.filterByType.length) {
            return media
        }

        return media.filter(object => {
            return !!this.filterByType.filter(type => object.mimeType.includes(type)).length
        })
    }

    public get compatibleSelection (): MediaObject | MediaObject[] {
        if (this.selected.length === 1) {
            return this.selected[0]
        }

        return this.selected
    }

    public getIcon (media: MediaObject) {
        switch (true) {
            case !media.mediaFound:
                return 'mdi-file-alert'
            case media.isImage:
                return 'photo'
            case media.isPDF:
                return 'mdi-file-outline'
            case media.isVideo:
                return 'mdi-video'
            default:
                return 'mdi-file'
        }
    }

    public mounted () {
        // Por el momento solo se filtra por imagen
        // this.filters.type = 'image'
        this.loadMediaObjects(this.filters)
    }

    public onMediaSelect (media: MediaObject) {
        // Si el elemento ya se encuentra seleccionado se elimina de la lista
        if (this.isSelected(media)) {
            this.removeMedia(media)

            return
        }

        if (this.multiselect) {
            this.selected.push(media)

            return
        }

        this.selected = [media]
    }

    public isSelected (media: MediaObject) {
        return this.selected.find(m => m.id === media.id) !== undefined
    }


    public removeMedia (media: MediaObject) {
        const index = this.selected.findIndex(m => m.id === media.id)
        if (index === -1) {
            return
        }

        this.selected.splice(index, 1)
    }

    /**
     * Método llamado cuando el usuario pulsa el botón de confirmación de selección
     */
    public onSelect () {
        // Cuando el usuario ha selecciona un archivo de la librería el componente
        // emite un evento con dicho archivo
        if (this.activeTab === 0) {
            this.$emit('select', this.compatibleSelection)
        }

        // Cuando el usuario ha subido nuevos archivos al administrador de subidas,
        // se procesa la cola de subida
        if (this.activeTab === 1) {
            this.loading = true
            this.$refs.uploadManager.upload()
        }

        // Resetea la lista de objetos multimedia seleccionados
        this.selected = []
    }

    /**
     * Método llamado cuando el administrador de subidas emite un evento indicando
     * que una subida se ha completado con existo. Emite otro evento con
     * los archivos subidos
     */
    public onUploadComplete (event: UploadCompletedEvent) {
        this.loading = false
        this.$emit('select', event.uploads[0].media)

        // Resetea el estado del administrador de subidas y elimina la cola
        // de archivos subidos
        this.$refs.uploadManager.clear()
    }

    /**
     * Indica si el usuario ha seleccionado algún archivo de la librería
     * o a subido alguno desde su PC, permite habilitar el botón
     * de confirmación de selección
     */
    get canSelect () {
        if (this.activeTab === 0) {
            return this.selected.length > 0
        }

        if (this.activeTab === 1) {
            return this.$refs.uploadManager.queue.length > 0
        }

        return false
    }
}
